import React from "react";

export default (props) => <div className="row">{props.children}</div>;



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/Row.jsx